import React, { PureComponent } from "react";
import "../widgets.scss";
import "./linechart.scss";
import wrapWidget from "../WidgetHOC";
import wrapMockedWidget from "../MockedWidgetHOC";
import { getTimetParamsFromWidgetConfig } from "../../../../../helpers/histo";

import Spinner from "../../../../generic/Spinner";

import GraphLine from "./GraphLine";
import YAxis from "./YAxis";
import XAxis from "./XAxis";
import Tooltips from "./Tooltips";

import { scaleLinear, scaleTime } from "d3-scale";
import { min as d3min, max as d3max } from "d3-array";
import { timeFormat } from "d3-time-format";

import {
  timeSecond,
  timeMinute,
  timeHour,
  timeDay,
  timeWeek,
  timeMonth,
  timeYear
} from "d3-time";


const PX_PER_TICK = 115;
// defaults
var N_TICKS_Y = 3;
var N_TICKS_X = 6;

const LineChart = class extends PureComponent {
  
  constructor(props) {
    super(props);
    this.state = { mouseX: 0, hovered: false };
    this.elem = undefined
   
  }

  mouseDidMove(evt) {
    // layout prop is injected by widgetHOC from LayoutContext of dashboard container
    let {containerScale = 1} = this.props.layout
    this.setState({mouseX:(evt.clientX - this.elem.getBoundingClientRect().x)/containerScale})
  }
 
  render() {
    var X_AXIS_WIDTH = 80;
    let {
      histoSensorValuesForSensors,
      coords,
      thisWidgetConfig,
      colorsForSensors,
      isMock
    } = this.props;
    //console.log("Linechart rerenders")
    //console.log("isMock", isMock)
    //console.log("LineChart render. histoSensorValuesForSensors:",      histoSensorValuesForSensors);
    // Special settings

    // Dont render the axis if the setting is false OR if the widget grid height is 1 or this is a mock widget.
    let hasUnitHeight = false;
    let renderAxes = true;
    try {
      hasUnitHeight = thisWidgetConfig && thisWidgetConfig.gridCoords && ((thisWidgetConfig.gridCoords.gridy2 - thisWidgetConfig.gridCoords.gridy1) < 2) || false;
      renderAxes = (thisWidgetConfig.widgetSettings.show_axes && !hasUnitHeight) === true;

      renderAxes = isMock ? false : renderAxes;
    } catch (error) {
      console.error(error);
    }

    X_AXIS_WIDTH = renderAxes ? X_AXIS_WIDTH : 0;

    if (
      !histoSensorValuesForSensors ||
      !histoSensorValuesForSensors[
        Object.keys(histoSensorValuesForSensors)[0]
      ] ||
      histoSensorValuesForSensors[Object.keys(histoSensorValuesForSensors)[0]]
        .length < 1
    ) {
      // TODO: Write "no data" component
      return <Spinner />;
    } else if (histoSensorValuesForSensors.length < 1) {
      return <div>Keine Daten</div>;
    }

    //console.log("55",histoSensorValuesForSensors[Object.keys(histoSensorValuesForSensors)[0]]);

    let widget_width,
      widget_height,
      padding_x,
      padding_y,
      xScale,
      yScale;


    try {
      widget_width = coords.x2 - coords.x1;
      widget_height = coords.y2 - coords.y1;
      padding_x = 20;
      padding_y = hasUnitHeight?13:50;

      // Calculate N_TICKS based on widget size
      N_TICKS_Y = Math.floor(widget_height / PX_PER_TICK );
      N_TICKS_Y = N_TICKS_Y < 3 ? 3 : N_TICKS_Y;

      N_TICKS_X = Math.floor(widget_width / PX_PER_TICK);
      N_TICKS_X = N_TICKS_X < 2 ? 2 : N_TICKS_X;
      //

      let {begin, end, limit} = getTimetParamsFromWidgetConfig(thisWidgetConfig)
     
      xScale = scaleTime()
        .domain([
          new Date(begin*1000),
          new Date(end*1000)
        ])
        .range([padding_x + X_AXIS_WIDTH, widget_width - padding_x * 2])
        .clamp(true)
        //.nice(timeMinute,3)
     

      // For now take the extent of the combination of all connected sensors!
      // TODO: not sure if this is the most efficient solution
      let extrema = Object.keys(histoSensorValuesForSensors).map(
        histoSensorValuesForSensorKey => {
          let histoSensorValuesForSensor =
            histoSensorValuesForSensors[histoSensorValuesForSensorKey];
          return {
            min: d3min(histoSensorValuesForSensor, row => {
              return parseFloat(row.value);
            }),
            max: d3max(histoSensorValuesForSensor, row => {
              return parseFloat(row.value);
            })
          };
        }
      );
      let yExtent = [
        d3min(extrema, row => parseFloat(row.min)),
        d3max(extrema, row => parseFloat(row.max))
      ];
      if (yExtent[0] === yExtent[1]) {
        yExtent[1] = yExtent[0] + 1
        yExtent[0] = yExtent[0] - 1
      }

      // TODO: make graph line also sit on bottom of the widget area.
      
      yScale = scaleLinear()
        .domain([yExtent[1], yExtent[0]])
        .range([ padding_y, widget_height - padding_y])
        .nice(N_TICKS_Y)
        .clamp(false);
    } catch (error) {
      console.error("LC", error);
    }

    // Indocator for rerendering graphline
    let ind = yScale.domain()[1]
    //console.log("ind", ind)

    let graphLines = Object.keys(histoSensorValuesForSensors).map(sensorid => {
      let histoSensorValuesForSensor = histoSensorValuesForSensors[sensorid];
      //console.log("660", histoSensorValuesForSensors)
      return (
        <GraphLine
          rerender={ind}
          key={"gl-" + sensorid + thisWidgetConfig.widgetid}
          sensorName={sensorid}
          xScale={xScale}
          yScale={yScale}
          _data={histoSensorValuesForSensor}
          color={colorsForSensors[sensorid]}
        />
      );
    });

    return (
      <div className="linechart-widget">
        <svg width={widget_width} height={widget_height} style={{"overflow": "visible"}} 
        onMouseMove={this.mouseDidMove.bind(this)}
        onMouseEnter={()=>{this.setState({hovered: true})}}
        onMouseLeave={()=>{this.setState({hovered: false})}}
        ref={el => {
          // el can be null - see https://reactjs.org/docs/refs-and-the-dom.html#caveats-with-callback-refs
          if (!el) return;
          this.elem = el
        }}
        >
          <g>
            {renderAxes && (
              <YAxis
                xScale={xScale}
                yScale={yScale}
                nTicksY={N_TICKS_Y}
                width={X_AXIS_WIDTH}
                height="100%"
              />
            )}
            {renderAxes && (
              <XAxis
                rerender={ind}
                xScale={xScale}
                yScale={yScale}
                nTicksX={N_TICKS_X}
                nTicksY={N_TICKS_Y}
              />
            )}

            {graphLines}
           {this.state.hovered && <Tooltips mouseX={this.state.mouseX} height={widget_height} xScale={xScale} yScale={yScale} values={histoSensorValuesForSensors} sensorKeys={Object.keys(histoSensorValuesForSensors)} colorsForSensors={colorsForSensors}/>}

          </g>
        </svg>

      </div>
    );
  }
};

const MockedLineChart = wrapMockedWidget(LineChart);
export { MockedLineChart };
export default wrapWidget(LineChart);
